import styled from "@emotion/styled"
import { Button } from "@pallet-hq/hegel"
import mixpanel from "mixpanel-browser"
import { BUTTON_TYPES, TRACK_EVENTS, EVENTS } from "constants/events"
import { useCandidateApplication } from "@pallet/features/onboardingL2/useCandidateApplication"
import { usePalletContext } from "utils/hooks/usePalletContext"
import Tooltip from "components/Tooltip"

const ButtonSection = () => {
    const { pallet } = usePalletContext()
    const { showModal } = useCandidateApplication()

    return (
        <Wrapper>
            <Tooltip id="disabledTip" place="top" effect="solid"></Tooltip>
            <Button
                variant="secondary"
                disabled
                onClick={() => {
                    mixpanel.track(TRACK_EVENTS.BUTTON_CLICKED, {
                        type: BUTTON_TYPES.APPLY_TO_COLLECTIVE,
                        applylist_slug: pallet,
                    })
                    mixpanel.track(EVENTS.COLLECTIVE_CLICK_APPLY, {
                        pallet: pallet,
                    })
                    showModal()
                }}
                data-for="disabledTip"
                data-tip="Pallet is no longer accepting applications. Check back later!"
            >
                Apply to join
            </Button>
            <Button
                ml={2}
                onClick={() => {
                    mixpanel.track(TRACK_EVENTS.BUTTON_CLICKED, {
                        type: BUTTON_TYPES.START_HIRING,
                        applylist_slug: pallet,
                    })
                }}
                disabled
                data-for="disabledTip"
                data-tip="New collective applications are currently closed. Check back later!"
            >
                Start hiring
            </Button>
        </Wrapper>
    )
}

export default ButtonSection

const Wrapper = styled.div`
    display: flex;
    justify-content: center;
    max-width: 316px;
    width: 100%;
`
